/**************************************************************
 *   If a navigation menu dropdown is clicked with a mouse,   *
 *   open a link to the page. Note that "clicking" with the   *
 *   enter button still opens the menu. A separate link must  *
 *   be added after the dropdown-toggle that is visible only  *
 *   when focus is applied to support users that do not use   *
 *   a mouse.                                                 *
 **************************************************************/

document.addEventListener('DOMContentLoaded', function () {
    var navDropdownElements = document.querySelectorAll('.navbar-nav .nav-link.dropdown-toggle');
    var dropdowns = [];

    navDropdownElements.forEach(function (dropdownToggle, index) {
        dropdowns[index] = bootstrap.Dropdown.getOrCreateInstance(dropdownToggle);
    });

    navDropdownElements.forEach(function (dropdownToggle, index) {
        var dropdownMenu = dropdownToggle.parentElement.querySelector('.dropdown-menu');

        dropdownToggle.addEventListener('mouseleave', function () {
            setTimeout(function () {
                if (!dropdownMenu.matches(':hover')) {
                    dropdowns[index].hide();
                }
            }, 100);
        });

        dropdownMenu.addEventListener('mouseleave', function () {
            setTimeout(function () {
                if (!dropdownToggle.matches(':hover')) {
                    dropdowns[index].hide();
                }
            }, 100);
        });

        dropdownToggle.addEventListener('mouseenter', function () {
            // Close other dropdowns when opening a new one
            dropdowns.map(dropdown => dropdown.hide());
            dropdowns[index].show();
        });

        dropdownToggle.addEventListener('click', function (e) {
            if (e.pointerType === 'mouse' && this.tagName.toUpperCase() === 'A' && this.hasAttribute('href')) {
                var href = this.getAttribute('href');
                if (href !== '#') {
                    e.preventDefault();
                    window.location.href = href;
                }
            }
        });
    });
});